var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlyer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60608 3.83118L2.39392 1.59739C1.73405 1.31459 1 1.79862 1 2.51654V11.3406C1 11.7406 1.2384 12.1022 1.60608 12.2597L7.60608 14.8312C7.85763 14.939 8.14237 14.939 8.39392 14.8312L14.3939 12.2597C14.7616 12.1022 15 11.7406 15 11.3406V2.51654C15 1.79862 14.2659 1.31459 13.6061 1.59739L8.39392 3.83118C8.14237 3.93898 7.85763 3.93898 7.60608 3.83118Z",
    stroke: "#555555",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4V15",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlyer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flyer.d59f33ea216b13c06b7f12939a3adec3.svg";